export const SYNC_TIMERS_FOR_SCENES = '@@timersForScenes/timersForScenesSync'
